// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Jx-z","slideIn":"Kx-z"};